module.exports = __webpack_public_path__ + "img/Wolf.5ddf6cf0.jpg";